import React from 'react'
import styles from "../../styles/screens/PrasadBox/PBContentVrindavan.module.css"
import DecorateFlower from "../../assets/prasad_gift/DecorateFlower.png"

import Vrindavan1 from '../../assets/holiprasad/1-removebg-preview.png'
import Vrindavan2 from '../../assets/holiprasad/2-removebg-preview.png'
import Vrindavan3 from '../../assets/holiprasad/3-removebg-previe.png'
import Vrindavan4 from '../../assets/holiprasad/4-removebg-previe.png'
import Vrindavan5 from '../../assets/holiprasad/5-removebg-previe.png'
import Vrindavan6 from '../../assets/holiprasad/6-removebg-previe.png'
import Vrindavan7 from '../../assets/holiprasad/7-removebg-previe.png'
import Vrindavan8 from '../../assets/holiprasad/8-removebg-preview.png'
import Vrindavan9 from '../../assets/holiprasad/9-removebg-previe.png'
import Vrindavan10 from '../../assets/holiprasad/10-removebg-preview.png'

const PBContentVrindavan = () => {
  const vrindavanItems = [
    { id: 1, image: Vrindavan1, alt: "Krishna prasad" },
    { id: 2, image: Vrindavan2, alt: "Radha prasad" },
    { id: 3, image: Vrindavan3, alt: "Krishna darbar" },
    { id: 4, image: Vrindavan4, alt: "Vrindavan chandan" },
    { id: 5, image: Vrindavan5, alt: "Vrindavan mala" },
    { id: 6, image: Vrindavan6, alt: "Vrindavan prasad item" },
    { id: 7, image: Vrindavan7, alt: "Vrindavan prasad item" },
    { id: 8, image: Vrindavan8, alt: "Vrindavan prasad item" },
    { id: 9, image: Vrindavan9, alt: "Vrindavan prasad item" },
    { id: 10, image: Vrindavan10, alt: "Vrindavan prasad item" },
  ];

  return (
    <div className={styles.contentsContainer}>
      <div className={styles.backgroundDecoration}>
        <img
          src={DecorateFlower}
          alt="Decorative mandala background"
          fill
          className={styles.mandalaImage}
        />
      </div>

      <h1 className={styles.mainTitle}>
        Vrindavan Prasad Box
      </h1>
      <div className={styles.titleUnderline}></div>

      <p className={styles.description}>
        Blessed pada from Shri Banke Bihari mandir along with blessed Krishna darbar, morpankh, rakshasutra and
        <br />
        more blessed items sourced directly from Vrindavan.
      </p>

      <p className={styles.includedText}>(What all is included ?)</p>

      <div className={styles.itemsGrid}>
        {vrindavanItems.map((item) => (
          <div
            key={item.id}
            className={styles.itemCard}
          >
            <img
              src={item.image}
              alt={item.alt}
              className={styles.itemImage}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default PBContentVrindavan